export default "__VITE_ASSET__CEGmgSsm__"